import { makeStyles } from '@material-ui/core/styles';
import theme from '../theme.js';

export const activeItemStyle = makeStyles({
  active: {
    color: `${theme.palette.secondary.main} !important`,
    fontWeight: '500'
  }
});
